import { computed } from 'vue';
import { useStore } from '@/utils/vue-api';

const MODULE_DEFAULT_COVERS = {
	'news': 'https://image.comein.cn/web/irm/irstore/news_default.png',
	'investment_activity': 'https://image.comein.cn/web/irm/irstore/custom_default.png'
};

export function useModuleDefaultCover() {
	const store = useStore();
	const getIrBaseInfo = computed(() => store.getters.getIrBaseInfo);

	const getDefaultCover = moduleId => {
		// 投关活动 不展示配置的默认封面
		if (moduleId === 'investment_activity') return null;

		const { coverPicture, coverPictureSwitch } = getIrBaseInfo.value;
		const defaultCover = coverPictureSwitch
			? coverPicture || MODULE_DEFAULT_COVERS[moduleId]
			: MODULE_DEFAULT_COVERS[moduleId];

		return defaultCover;
	};

	return {
		getDefaultCover
	};
}
